export type PossibleKind = 'PDP' | 'CrLandingPage'; /*                                           */
export type CrFilter = 'oneStar' | 'twoStar' | 'threeStar' | 'fourStar' | 'fiveStar' | 'all';

export const isCrFilter = (value: string): value is CrFilter => {
    return ['oneStar', 'twoStar', 'threeStar', 'fourStar', 'fiveStar', 'all'].includes(value);
};
